module.exports = __webpack_public_path__ + "img/money_o.0b0d7183.svg";